import { parseCookie } from "cookie";
import type { IUserInfo } from "./account/account-models";
import { isStandalone } from "./utils/detectors";

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const GIT_SHA1 = import.meta.env.VITE_GIT_SHA1;
export const GIT_BRANCH = import.meta.env.VITE_GIT_BRANCH;
export const IS_PROD = ENVIRONMENT === "production";

export const SLACK_HOOK_URL = "https://crimson-leaf-ca6f.heath973.workers.dev";
export const FINGERPRINT_API_KEY = "z43Lh8rcPoR62T0M4L0Z";
export const FINGERPRINT_ENDPOINT = "https://fp.alua.com";
export const GIPHY_API_KEY = "tRfPNFAh71iT4MV3IhWcvGQ7pCB0zAk4";
export const POSTHOG_KEY = "phc_3nu9sLBOBUnByNvfEFIr7Dyw7g3kzIujDFh9ThdaT6d";

const BRANCH_IO_KEY_DEV = "key_test_loqb4OCc7tJK7jtZKcCAkapfBrgOHa3U";
const BRANCH_IO_KEY_PROD = "key_live_ajEaYJwf1tHJ2fzYMajWSlobAAhRKo6C";
export const BRANCH_IO_KEY = IS_PROD ? BRANCH_IO_KEY_PROD : BRANCH_IO_KEY_DEV;

const VAPID_PUBLIC_KEY_DEV =
  "BNJNqmWGO3sbclIyHHSmGnWgNn_FsNk_Y7kO2Q6cDBcJ9Jc87HypXiWpXHhHRNWaknYT8nsnY9AeLwtEghWvyVM";
const VAPID_PUBLIC_KEY_PROD =
  "BIz8_tmaHDgFnBxYV5izTxHc5sZInOShPwbkjidzwqHWnQ_N5fzdSVHHwlDFA1pJ1mHpKzPhXyAwCqBbawBHVzs";
export const VAPID_PUBLIC_KEY = IS_PROD
  ? VAPID_PUBLIC_KEY_PROD
  : VAPID_PUBLIC_KEY_DEV;
export const IS_LOCAL = ENVIRONMENT === "local";
export const IS_LOCAL_API =
  window.location.hostname === "web.41u4.test" ||
  window.location.hostname === "test.41u4.com";

export const DOMAIN_COOKIE = IS_PROD
  ? ".alua.com"
  : IS_LOCAL || IS_LOCAL_API
    ? null
    : window.location.hostname === "web.alua555.com"
      ? ".alua555.com"
      : ".41u4.com";
export const DEFAULT_EXPIRY_DAYS_COOKIE = 1460;
export const URL_YII = IS_PROD
  ? "https://alua.com"
  : IS_LOCAL_API
    ? "https://41u4.test"
    : window.location.hostname === "web.alua555.com"
      ? "https://alua555.com"
      : "https://41u4.com";
export const URL_LOGIN = IS_LOCAL || isStandalone ? "/login" : URL_YII;
export const URL_JOIN = URL_YII.replace(/^(https?:\/\/)/, "$1join.");
export const URL_BLOG = `https://alua.com/blog`;

const getApiRoot = (): string => {
  let apiRoot = "https://api.alua.com";

  const apiRootFromCookie = parseCookie(document.cookie)["custom_api_base_url"];
  if (apiRootFromCookie) {
    apiRoot = apiRootFromCookie;
  } else {
    if (!IS_PROD) {
      if (IS_LOCAL_API) {
        apiRoot = "https://api.41u4.test";
      } else if (window.location.hostname === "web0.41u4.com") {
        apiRoot = "https://api0.41u4.com";
      } else if (window.location.hostname === "web.alua555.com") {
        apiRoot = "https://api.alua555.com";
      } else {
        apiRoot = "https://api.41u4.com";
      }
    }
  }

  return apiRoot;
};
export const API_ROOT = getApiRoot();

const getMediaRoot = (): string => {
  let mediaRoot = "https://upload.alua.com";

  if (!IS_PROD) {
    if (IS_LOCAL_API) {
      mediaRoot = "https://upload.41u4.test";
      // } else if (window.location.hostname === "web0.41u4.com") {
      //   mediaRoot = "https://api0.41u4.com";
    } else if (window.location.hostname === "web.alua555.com") {
      mediaRoot = "https://upload.alua555.com";
    } else {
      mediaRoot = "https://upload.41u4.com";
    }
  }

  return mediaRoot;
};
export const MEDIA_ROOT = getMediaRoot();

const getWsRoot = (): string => {
  let wsRoot = "wss://ws.alua.com:8443";

  const wsRootFromCookie = parseCookie(document.cookie)["custom_ws_base_url"];
  if (wsRootFromCookie) {
    wsRoot = wsRootFromCookie;
  } else {
    if (!IS_PROD) {
      if (IS_LOCAL_API) {
        wsRoot = "wss://ws.41u4.test:38443";
      } else if (window.location.hostname === "web0.41u4.com") {
        wsRoot = "wss://ws0.41u4.com:8443";
      } else if (window.location.hostname === "web.alua555.com") {
        wsRoot = "wss://ws.alua555.com:8443";
      } else {
        wsRoot = "wss://ws.41u4.com:8443";
      }
    }
  }

  return wsRoot;
};
export const WS_ROOT = getWsRoot();

export const AUTH_TOKEN_NAME = "auth-token";

export const DEFAULT_JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

// Viewport sizes

export const FROM_SM_MOBILE = 350;
export const FROM_TABLET = 768;
export const FROM_LAPTOP = 1152;
export const FROM_DESKTOP = 1440;
export const FROM_WIDE = 1920;

export const ALUA_SUPPORT_USERNAME = "aluasupport";
export const ALUA_SUPPORT_USER_ID = IS_PROD
  ? "57da87bc933d4c000f1dbc69"
  : "5c18b1fae1bfd776f7392a52";
export const ALUA_INFO_USERNAME = "aluainfo";

export const DEFAULT_ERROR_MESSAGE =
  "Something went wrong. Please try again later.";

export const MAX_PROFILE_PHOTOS_COUNT = 12;

export const TRUSTPILOT_LINK = "https://www.trustpilot.com/review/alua.com";

export const UNRELIABLE_EMAIL_DOMAINS = [
  "@yahoo",
  "@outlook",
  "@hotmail",
  "@icloud",
];

export const isMassPayPayoutsNotAvailable = (user: IUserInfo): boolean => {
  // return user.credits > 1000;
  return false;
};
export const isPaxumPayoutsNotAvailable = (user: IUserInfo): boolean => false;
export const isPayPalPayoutsNotAvailable = (user: IUserInfo): boolean => false;
export const isBankPayoutsNotAvailable = (user: IUserInfo): boolean => {
  // return user.credits > 1000;
  return false;
};
export const isCryptoPayoutsNotAvailable = (user: IUserInfo): boolean => false;

// Using ⚠ + variation selector (⚠️) to force emoji-style rendering.
// Without \uFE0F, some platforms (esp. Android Chrome) may show a plain
// black-and-white text symbol instead of the colorful emoji.
export const WARNING_EMOJI = "\u26A0\uFE0F";

export const GOOGLE_AUTHENTICATOR_LINK_IOS =
  "https://apps.apple.com/app/google-authenticator/id388497605";
export const GOOGLE_AUTHENTICATOR_LINK_ANDROID =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US";

export const AUTHY_LINK_IOS = "https://apps.apple.com/app/authy/id494168017";
export const AUTHY_LINK_ANDROID =
  "https://play.google.com/store/apps/details?id=com.authy.authy&hl=en&gl=US";
